import React from 'react';
import Icon from '../../icon/index';
import { SearchResultContext } from '../context/SearchResultContext';
import { trackSearchEvent } from '../api/request';
import NoResults from './NoResults';

const Documents = (props) => {

    const { results, language, endpoint, sortOrder, setSortOrder } = React.useContext(SearchResultContext);
    const [smallScreen, setSmallScreen] = React.useState(false);
    const [overflowLeft, setOverflowLeft] = React.useState(false);
    const [overflowRight, setOverflowRight] = React.useState(true);
    const [showIcon, setShowIcon] = React.useState(true);

    const handleScroll = () => {
        const el = document.getElementById('search-result-page-client');
        setTimeout(() => {
            if (el) {
                // Try scrollIntoView first, with fallback to scrollTo
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                // Fallback to scroll to top if element not found
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 250);
    };

    const handleSort = (column) => {
        const columnMap = {
            document: 'DocumentName',
            article: 'DocumentArticle',
            type: 'DocumentType',
            size: 'DocumentSize',
            format: 'DocumentFormat'
        };

        const prefix = columnMap[column];
        const azOrder = `${prefix}AZ`;
        const zaOrder = `${prefix}ZA`;

        if (sortOrder === azOrder) {
            setSortOrder(zaOrder);
        } else if (sortOrder === zaOrder) {
            setSortOrder('');
        } else {
            setSortOrder(azOrder);
        }
    };

    const getSortIcon = (column) => {
        const columnMap = {
            document: 'DocumentName',
            article: 'DocumentArticle',
            type: 'DocumentType',
            size: 'DocumentSize',
            format: 'DocumentFormat'
        };

        const prefix = columnMap[column];
        const azOrder = `${prefix}AZ`;
        const zaOrder = `${prefix}ZA`;

        if (sortOrder === azOrder) {
            return <Icon icon="sort-descending" />;
        } else if (sortOrder === zaOrder) {
            return <Icon icon="sort-ascending" />;
        }
        return '';
    };

    React.useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        setSmallScreen(mediaQuery.matches);
        const handleResize = (e) => setSmallScreen(e.matches);
        mediaQuery.addEventListener('change', handleResize);
        return () => mediaQuery.removeEventListener('change', handleResize);
    }, []);

    React.useEffect(() => {
        if (sortOrder)
            handleScroll();
    }, [sortOrder]);

    // Handle horizontal scroll for overflow indicators
    React.useEffect(() => {
        const handleScrollEvent = (e) => {
            const scroller = e.target;
            const scrollLeft = scroller.scrollLeft;
            const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

            // Hide icon permanently after first scroll
            setShowIcon(false);

            setOverflowLeft(scrollLeft > 0);
            setOverflowRight(scrollLeft < maxScrollLeft);
        };

        const scrollerElement = document.querySelector('.horizontal-scroller__scroller');
        if (scrollerElement) {
            scrollerElement.addEventListener('scroll', handleScrollEvent);

            // Check initial state
            const initialScrollLeft = scrollerElement.scrollLeft;
            const initialMaxScrollLeft = scrollerElement.scrollWidth - scrollerElement.clientWidth;
            setOverflowLeft(initialScrollLeft > 0);
            setOverflowRight(initialScrollLeft < initialMaxScrollLeft);
        }

        return () => {
            if (scrollerElement) {
                scrollerElement.removeEventListener('scroll', handleScrollEvent);
            }
        };
    }, [results.items]);

    return (
        <>
            {results.items.length <= 0 ? <NoResults heading={props.noResultsHeading} preamble={props.noResultsPreamble} query={props.query} /> : null}
            <div className={`${results.items.length <= 0 ? 'search-result-documents-heading-no-results' : 'search-result-documents-heading'}`}>
                <h2 className='headline-4 h-margin-bottom-1-important'>{props.searchDocumentsHeading}</h2>
                <div className='h-text-align-center' dangerouslySetInnerHTML={{ __html: props.searchDocumentsPreamble || '' }}></div>
            </div>
            {results.items.length <= 0 ? null
                : <div className='panel panel--compact  theme--grey  panel--no-padding-top panel--no-padding-bottom   '>
                    <div className='panel__inner'>
                        <div className='filters'>
                            <div className={`horizontal-scroller ${smallScreen ? [
                                showIcon ? 'horizontal-scroller--show-icon' : '',
                                overflowLeft ? 'horizontal-scroller--overflow-left' : '',
                                overflowRight ? 'horizontal-scroller--overflow-right' : ''
                            ].filter(Boolean).join(' ') : ''}`}>
                                <div className='horizontal-scroller__scroller'>
                                    <table className='table table--zebra h-margin-top-4 search-results-documents' role='table' aria-label='Search results documents table'>
                                        <thead>
                                            <tr>
                                                <th aria-sort={sortOrder === 'DocumentNameAZ' ? 'ascending' : sortOrder === 'DocumentNameZA' ? 'descending' : 'none'}>
                                                    <button
                                                        aria-pressed={sortOrder === 'DocumentNameAZ' || sortOrder === 'DocumentNameZA'}
                                                        aria-label={`${props.downloadTableDocument ? props.downloadTableDocument : ''} ${sortOrder === 'DocumentNameAZ' ? props.screenReaderAscendingText : sortOrder === 'DocumentNameZA' ? props.screenReaderDescendingText : props.screenReaderNoSortText}`}
                                                        className={`button-link`}
                                                        onClick={() => handleSort('document')}
                                                    >
                                                        {props.downloadTableDocument ? props.downloadTableDocument : ''} {getSortIcon('document')}

                                                    </button>
                                                </th>
                                                <th aria-sort={sortOrder === 'DocumentArticleAZ' ? 'ascending' : sortOrder === 'DocumentArticleZA' ? 'descending' : 'none'}>
                                                    <button
                                                        aria-pressed={sortOrder === 'DocumentArticleAZ' || sortOrder === 'DocumentArticleZA'}
                                                        aria-label={`${props.downloadTableArticle ? props.downloadTableArticle : ''} ${sortOrder === 'DocumentArticleAZ' ? props.screenReaderAscendingText : sortOrder === 'DocumentArticleZA' ? props.screenReaderDescendingText : props.screenReaderNoSortText}`}
                                                        className={`button-link`}
                                                        onClick={() => handleSort('article')}
                                                    >
                                                        {props.downloadTableArticle ? props.downloadTableArticle : ''} {getSortIcon('article')}

                                                    </button>
                                                </th>
                                                <th className='documents' aria-sort={sortOrder === 'DocumentTypeAZ' ? 'ascending' : sortOrder === 'DocumentTypeZA' ? 'descending' : 'none'}>
                                                    <button
                                                        aria-pressed={sortOrder === 'DocumentTypeAZ' || sortOrder === 'DocumentTypeZA'}
                                                        aria-label={`${props.downloadTableType ? props.downloadTableType : ''} ${sortOrder === 'DocumentTypeAZ' ? props.screenReaderAscendingText : sortOrder === 'DocumentTypeZA' ? props.screenReaderDescendingText : props.screenReaderNoSortText}`}
                                                        className={`button-link`}
                                                        onClick={() => handleSort('type')}
                                                    >
                                                        {props.downloadTableType ? props.downloadTableType : ''} {getSortIcon('type')}

                                                    </button>
                                                </th>
                                                <th aria-sort={sortOrder === 'DocumentSizeAZ' ? 'ascending' : sortOrder === 'DocumentSizeZA' ? 'descending' : 'none'}>
                                                    <button
                                                        aria-pressed={sortOrder === 'DocumentSizeAZ' || sortOrder === 'DocumentSizeZA'}
                                                        aria-label={`${props.downloadTableSize ? props.downloadTableSize : ''} ${sortOrder === 'DocumentSizeAZ' ? props.screenReaderAscendingText : sortOrder === 'DocumentSizeZA' ? props.screenReaderDescendingText : props.screenReaderNoSortText}`}
                                                        className={`button-link`}
                                                        onClick={() => handleSort('size')}
                                                    >
                                                        {props.downloadTableSize ? props.downloadTableSize : ''} {getSortIcon('size')}

                                                    </button>
                                                </th>
                                                <th aria-sort={sortOrder === 'DocumentFormatAZ' ? 'ascending' : sortOrder === 'DocumentFormatZA' ? 'descending' : 'none'}>
                                                    <button
                                                        aria-pressed={`${props.downloadTableDocument ? props.downloadTableDocument : ''} ${sortOrder === 'DocumentFormatAZ' || sortOrder === 'DocumentFormatZA'}`}
                                                        aria-label={`${sortOrder === 'DocumentFormatAZ' ? props.screenReaderAscendingText : sortOrder === 'DocumentFormatZA' ? props.screenReaderDescendingText : props.screenReaderNoSortText}`}
                                                        className={`button-link`}
                                                        onClick={() => handleSort('format')}
                                                    >
                                                        {props.downloadTableFormat ? props.downloadTableFormat : ''} {getSortIcon('format')}

                                                    </button>
                                                </th>
                                                <th>
                                                    <div>
                                                        {props.downloadTableDownload ? props.downloadTableDownload : ''}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {results.items.map((item) => {
                                                return (
                                                    item.searchHitObject &&
                                                    <tr>
                                                        <td>
                                                            <a onClick={() => trackSearchEvent(language, endpoint, results.query, item.hitId)} href={item.url} title={item.title} target={item.target} className='fileLink'>

                                                                {item.title}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {item.searchHitObject.articleNumber ? item.searchHitObject.articleNumber : ''}
                                                        </td>
                                                        <td>
                                                            {item.searchHitObject.docType ? item.searchHitObject.docType : ''}
                                                        </td>
                                                        <td>
                                                            {item.searchHitObject.sizeInKb ? Math.round(item.searchHitObject.sizeInKb * 100) / 100 : ''}kB
                                                        </td>
                                                        <td>
                                                            {item.searchHitObject.fileType ? item.searchHitObject.fileType : ''}
                                                        </td>
                                                        <td>
                                                            <a href={item.searchHitObject.docUrl ? item.searchHitObject.docUrl : '/'} download className="table__icon ">

                                                                <Icon icon="download" additionalClasses="table-icon"></Icon>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                );
                                            })}

                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            }
        </>

    );
};

export default Documents;
